import script from "./GeneralMixin.vue?vue&type=script&lang=js"
export * from "./GeneralMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__